export const parseEventDate = (value) => {
  if (!value) return null;

  // If just a date, keep it local to avoid UTC shifts
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map((n) => parseInt(n, 10));
    return new Date(y, m - 1, d);
  }

  // Normalize space-separated datetime to ISO-like before letting Date parse offsets
  if (typeof value === 'string' && value.includes(' ')) {
    return new Date(value.replace(' ', 'T'));
  }

  return new Date(value);
};
